(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    (function () {
  const first = document.getElementById('ContactForm-first-name');
  const last = document.getElementById('ContactForm-last-name');
  const combined = document.getElementById('ContactForm-name');

  function syncName() {
    combined.value = [first.value, last.value].filter(Boolean).join(' ');
  }

  if (first) first.addEventListener('input', syncName);
  if (last) last.addEventListener('input', syncName);

  var reasonLabels = document.querySelectorAll('.reason-btn');
  reasonLabels.forEach(function(label){
    var input = label.querySelector('input[type="radio"]');
    label.addEventListener('click', function(){
      input.checked = true;
      reasonLabels.forEach(function(l){
        l.classList.remove('reason-btn--selected');
        l.setAttribute('aria-checked', 'false');
      });
      label.classList.add('reason-btn--selected');
      label.setAttribute('aria-checked', 'true');
    });
    label.addEventListener('keydown', function(e){
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        label.click();
      }
    });
  });

  reasonLabels.forEach(function(label){
    var input = label.querySelector('input[type="radio"]');
    if (input && input.checked) {
      label.classList.add('reason-btn--selected');
      label.setAttribute('aria-checked', 'true');
    }
  });

  var fileInput = document.getElementById('ContactForm-upload');
  var uploadLabel = document.querySelector('.upload-btn');
  if (fileInput && uploadLabel) {
    fileInput.addEventListener('change', function(e){
      var f = e.target.files && e.target.files[0];
      if (f) {
        uploadLabel.textContent = 'FILE SELECTED';
      } else {
        uploadLabel.textContent = 'UPLOAD';
      }
    });
  }
})();
  } catch(e) { console.error(e); }
})();

})();
